import type { SubscribedUser } from "@/types/subscription";

export const formatMembershipDate = (dateString: string | null | undefined) => {
  if (!dateString) return "—";

  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatPrice = (amount: number | null | undefined) => {
  if (amount == null) return "—";
  return Number(amount).toFixed(1);
};

export const formatStatusLabel = (status: string | null | undefined) => {
  if (!status) return "—";
  return status.charAt(0) + status.slice(1).toLowerCase();
};

export const getDurationLabel = (months: number | null | undefined) => {
  if (!months) return "Per month";
  if (months === 1) return "Per month";
  return `Per ${months} months`;
};

export const formatPlanDurationShort = (months: number | null | undefined) => {
  if (!months) return "1 month";
  if (months === 1) return "1 month";
  return `${months} month`;
};

export const formatPayAmount = (amount: number | null | undefined) => {
  if (amount == null) return "—";
  return Number(amount).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const getQueuedPlan = (subscription: SubscribedUser | null) =>
  subscription?.planQueued && subscription?.queuedSubscription
    ? subscription.queuedSubscription
    : null;

export const hasQueuedSubscriptionData = (subscription: SubscribedUser | null) =>
  Boolean(
    getQueuedPlan(subscription) ||
      subscription?.queuedSubscription?.planId ||
      subscription?.pendingSubscriptionId,
  );

export const hasActiveSubscription = (subscription: SubscribedUser | null) =>
  Boolean(subscription?.planId && subscription?.status);

export const isQueuedOnlySubscription = (subscription: SubscribedUser | null) =>
  Boolean(getQueuedPlan(subscription) && !hasActiveSubscription(subscription));
